import { CliError } from "@/lib/cli/cli-error";
import { excerpt } from "@/lib/excerpt/excerpt";
import { CLI_ERROR_CODES } from "@/lib/shared/errors-constants";

export function parseResponsePayload(
  response: Response,
  text: string,
  request: { method: string; url: URL; retryAfter: number | undefined },
): unknown {
  const { method, url, retryAfter } = request;

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    const body = excerpt(text);
    const contentType = response.headers.get("content-type") ?? "unknown";
    // A non-JSON error is primarily an upstream failure, not a URL diagnosis.
    throw new CliError(
      response.ok
        ? `${method} ${url.pathname} answered ${response.status} with a non-JSON body (${contentType}). Is HEPHA_URL pointing at a Hephaistos deployment?${body ? ` Body: ${body}` : ""}`
        : `${method} ${url.pathname} failed with ${response.status} and a non-JSON body (${contentType}).${body ? ` Body: ${body}` : ""}`,
      1,
      {
        status: response.status,
        code: CLI_ERROR_CODES.NON_JSON_RESPONSE,
        ...(retryAfter === undefined ? {} : { retryAfterSeconds: retryAfter }),
      },
    );
  }
}
